import { Component, input } from '@angular/core';

@Component({
  selector: 'app-display-like-code',
  standalone: false,
  templateUrl: './display-like-code.component.html',
  styleUrl: './display-like-code.component.scss',
})
export class DisplayLikeCodeComponent {
  readonly value = input<string>('');
}
